<template>
  <el-tabs v-model="index" @tab-click="handleClick">
    <slot name="tab"></slot>
  </el-tabs>
</template>

<script>
export default {
  name: 'pdTabs',
  data () {
    return {
      index: 0
    }
  },
  methods: {
    handleClick (tab, event) {
      this.$emit('click', tab)
    }
  }
}
</script>

<style scoped>

</style>
